module.exports = __webpack_public_path__ + "img/ftes.488adf3c.svg";